<template>
  <div class="top-right-cmp">
    <div class="chart-name" :style="{color: Global.globalColor}">
      已购买企业信息
      <dv-decoration-3 style="width: calc(100vw * 260 / 1920); height: calc(100vw * 20 / 1920);"  :color="[Global.globalColor ,'#E0E1E2']" />
    </div>
    <dv-charts :option="option" />
  </div>
</template>

<script>
import emitter from '../../unit/bus'
import { mapState } from "vuex";
export default {
  data () {
    return {
      option: {
      }
    }
  },
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
      Commit: (state) => state.user.commit,
    }),
  },
  watch: {
    Commit (val) {
      if (!isNaN(val)){
        this.GetSPurchaseEnterpriseType();
      }
    },
    Round (val) {
      if (!isNaN(val)) {
        this.GetSPurchaseEnterpriseType();
      }
    },
  },
  created () {
    emitter.on("Purchase", (msg) => {
      console.log(msg)
      this.GetSPurchaseEnterpriseType()
    })
  },
  mounted () {
    this.GetSPurchaseEnterpriseType()
  },
  methods: {
    GetSPurchaseEnterpriseType () {
      this.$http.get(`Company/GetSPurchaseEnterpriseType?round=${this.Round}`).then((res) => {
        if (res.success) {
          this.option = {
            color:  this.Global.chartColor,
            series: [
              {
                type: 'pie',
                data: [
                  { name: '已购买', value: res.dynamicObj.purchase },
                  { name: '未够买', value: res.dynamicObj.notpurchased },
                ],
                insideLabel: {
                  show: true,
                }
              }
            ]
          }
        }
      })
    },
  }
}
</script>


<style lang="less">
.top-right-cmp {
  position: relative;
  padding: 0 50px;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  .chart-name {
    position: absolute;
    right: calc(100vw * 50 / 1920);
    text-align: right;
    font-size:calc(100vw * 22 / 1920);
    top: calc(100vw * 10 / 1920);
  }
}
.dv-charts-container {
  position: relative;
  width: 100%;
  height: 100%;
}
.dv-charts-container .charts-canvas-container {
  width: 100%;
  height: 100%;
}
</style>